module.exports = __webpack_public_path__ + "static/media/girl2.703dc04c.jpg";